import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { EstimatePlansTakeOffsStatesV2 } from '../../feat-estimate-plans-take-offs-v2/domain';
import { EstimateMeasurementCategoryVM } from '../feat-estimate-measurements-v2/domain';

@Component({
    selector: 'app-estimate-measurement-category-actions',
    templateUrl: './estimate-measurement-category-actions.component.html',
    styleUrls: ['./estimate-measurement-category-actions.component.scss'],
    standalone: false,
})
export class EstimateMeasurementCategoryActionsComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() states: EstimatePlansTakeOffsStatesV2;
    // @ts-ignore TS2564
    @Input() measurementCategory: EstimateMeasurementCategoryVM;

    @Output() toggleCategoryChanges = new EventEmitter();
    @Output() deleteCategoryChanges = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    public onDelete() {
        this.deleteCategoryChanges.emit();
    }

    public toggleCategory() {
        this.toggleCategoryChanges.emit();
    }
}

@NgModule({
    declarations: [EstimateMeasurementCategoryActionsComponent],
    imports: [CommonModule, MatButtonModule],
    exports: [EstimateMeasurementCategoryActionsComponent],
})
export class EstimateMeasurementCategoryActionsModule {}
